'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeRoomConfig = {
    fromJson: fromJson,
    getRoomConfig: getRoomConfig,
};

function fromJson(data) {
    var reqProps = [ '$roomId' ];
    return FirebaseObject.$fromJson(data, 'RoomConfig', reqProps, reqProps,
        function(data) { return getRoomConfig(data.$roomId); }
    );
}

// Returns a promise that resolves to the RoomConfig object when it is loaded.

function getRoomConfig(roomId) {
    var key = 'RoomConfig: ' + roomId;
    var config = KayleeCache.get(key);

    if (config === null) {
        config = new RoomConfig(roomId);
        KayleeCache.put(key, config);
    }

    return config;
}

function RoomConfig(roomId) {
    this.$nodeType = 'roomConfig';
    this.$roomId = roomId;
    this.$supportEmptyObject = true;
    FirebaseObject.call(this, KayleeBase.app.database().ref('roomConfig/' + roomId));
}

RoomConfig.prototype = Object.create(FirebaseObject.prototype);
RoomConfig.prototype.constructor = RoomConfig;

RoomConfig.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$roomId' ], {});
};

RoomConfig.prototype.toString = function() {
    return '[RoomConfig (' + this.$id + ')]';
};

module.exports = KayleeRoomConfig;
